module.exports = __webpack_public_path__ + "static/media/at.0d38e4d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/at.svg
// module id = 53
// module chunks = 0